
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91id_933tysGYGVNVDe1OXObjIq451R_45idyb0ZoDs0HbtsGXNwMeta } from "/opt/build/repo/pages/blog/[id].vue?macro=true";
import { default as indexbf9GgBYlDr166merohaW6l54mGuIZ0Wi0Swawj1_9rYMeta } from "/opt/build/repo/pages/blog/index.vue?macro=true";
import { default as blogott0gEtTQ54v6DRdlKf31kyIevIxP_XAC9xUUVixlzYMeta } from "/opt/build/repo/pages/blog.vue?macro=true";
import { default as _91id_93feR7KdCmUQji_4sBZ_JPSWrOC6JFfBg1c3sfMezD3RgMeta } from "/opt/build/repo/pages/work/[id].vue?macro=true";
import { default as indexHS_hLr2l2eHx2Ioe17Y6oyfteIYkhRjNe5DKEkpTgRYMeta } from "/opt/build/repo/pages/work/index.vue?macro=true";
import { default as workFVT4Oc56BMkMqoA__45XLab9huEkZK6ua2_XXSaS8GjRAMeta } from "/opt/build/repo/pages/work.vue?macro=true";
import { default as indexaAs6F0uOO1PbNxqH8DD_45e04gSZQCarVD9TCXJYV94KEMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as success1mGe5OE3_m9g8AGF6czi2K7Ml0A8TubYT0fLvhZcMsIMeta } from "/opt/build/repo/pages/success.vue?macro=true";
import { default as indexQYBbwqmeFTKzOeFn46eoFndAdLwT1cl0WWM2kbgbDLcMeta } from "/opt/build/repo/pages/about/index.vue?macro=true";
import { default as component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: blogott0gEtTQ54v6DRdlKf31kyIevIxP_XAC9xUUVixlzYMeta?.name,
    path: "/blog",
    component: () => import("/opt/build/repo/pages/blog.vue"),
    children: [
  {
    name: "blog-id",
    path: ":id()",
    component: () => import("/opt/build/repo/pages/blog/[id].vue")
  },
  {
    name: "blog",
    path: "",
    component: () => import("/opt/build/repo/pages/blog/index.vue")
  }
]
  },
  {
    name: workFVT4Oc56BMkMqoA__45XLab9huEkZK6ua2_XXSaS8GjRAMeta?.name,
    path: "/work",
    component: () => import("/opt/build/repo/pages/work.vue"),
    children: [
  {
    name: "work-id",
    path: ":id()",
    component: () => import("/opt/build/repo/pages/work/[id].vue")
  },
  {
    name: "work",
    path: "",
    component: () => import("/opt/build/repo/pages/work/index.vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/opt/build/repo/pages/success.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/opt/build/repo/pages/about/index.vue")
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/work/sitesearhai",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  }
]